import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import { styled } from '@mui/system';

const GradientText = styled(Typography)({
    background: 'linear-gradient(90deg, rgba(255,0,150,1) 0%, rgba(0,204,255,1) 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  });


const ContactSection = () => {
  return (
    <Box
      sx={{
        background: 'linear-gradient(to bottom, #d6efff, #ffe8d6)',
        textAlign: 'center',
        padding: '80px 20px',
      }}
    >
      <GradientText variant="overline" sx={{ color: 'magenta', fontWeight: 'bold', mb: 2,fontSize:'15px',fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
      Let's work together
     </GradientText>
      <Typography variant="h3" sx={{ fontWeight: 'bold', marginBottom: '32px', color: '#19274d',fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
        We Love to Listen to Your Requirements
      </Typography>
      <Button
        variant="contained"
        sx={{
          background: '#233098',
          color: 'white',
          padding: '10px 30px',
          fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
          borderRadius: '30px',
          boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.1)',
          '&:hover': {
            background: '#233098',
          },
        }}
      >
        Enquiry Now
      </Button>
      <Box mt={4} display="flex" justifyContent="center" alignItems="center">
        <Typography variant="body1" sx={{ color: '#6a6a6a', marginRight: '8px',fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
          Or call us now
        </Typography>
        <PhoneIcon sx={{ color: '#6a6a6a', marginRight: '8px' }} />
        <Typography variant="body1" sx={{ color: '#6a6a6a', fontWeight: 'bold',fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
          +91 96865 22212
        </Typography>
      </Box>
    </Box>
  );
};

export default ContactSection;
